import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import {  DashboardsView, NewDashboardButton } from '../features/Dashboard'
import { useIntl } from 'react-intl';
import { useState } from "react";

const Dashboard = () => {
    const intl = useIntl();
    const [refetch,setRefetch] = useState<Date | undefined>();
    const handleNewDashboardAdded = () => setRefetch(new Date());
    return (
        <Page header={intl.formatMessage({ id: "Pages.Dashboards.header", defaultMessage: "Dashboards" })}
            subheader={intl.formatMessage({ id: "Pages.Dashboards.subheader", defaultMessage: "all your favorites in one place" })}
            bottomButtons={[<NewDashboardButton onDashboardCreated={handleNewDashboardAdded}></NewDashboardButton>]}>
            <DashboardsView refetch={refetch}></DashboardsView>
        </Page>
    )
}

export default withAITracking(reactPlugin, Dashboard);